import { integrationsService } from '@/services/integrations';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/**
 * Emissão manual: informa o nº da apólice já emitida no i4Pro.
 *
 * A mutation NÃO lança em erro de negócio — devolve o envelope
 * `{ success, error }` para o modal de confirmação exibir a mensagem inline
 * (apólice inexistente, de outro ramo/produto, já vinculada a outra proposta,
 * i4Pro indisponível) sem se fechar e sem perder o número digitado. Mesmo padrão
 * das mutations do Balde de Apólices.
 */
export function useManualEmission() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      policyId,
      i4proPolicyNo,
      policyPdf,
    }: {
      policyId: string;
      i4proPolicyNo: string;
      policyPdf?: File | null;
    }) =>
      integrationsService.manualEmission(policyId, i4proPolicyNo, policyPdf),
    onSuccess: (response, { policyId }) => {
      if (!response.success) return;

      queryClient.invalidateQueries({
        queryKey: ['integration-details', policyId],
      });
      queryClient.invalidateQueries({ queryKey: ['integrations'] });
      // A apólice passa a existir: a proposta e as listagens mudam de status.
      queryClient.invalidateQueries({ queryKey: ['proposal', policyId] });
      queryClient.invalidateQueries({ queryKey: ['proposals'] });
      queryClient.invalidateQueries({ queryKey: ['policies'] });
      // RD Equipamentos usa este mesmo botão/modal dentro do próprio wizard
      // (ver `StepEmissao`) — `policyId` ali é o `proposalId` do RD. Invalidar
      // uma chave que não existe para outros produtos é um no-op inofensivo.
      queryClient.invalidateQueries({ queryKey: ['rd-proposal', policyId] });
    },
  });
}
